export const SENGRID_HIDDEN_EMAIL_OPT_OUT_OPTIONS = ['Realtor Itinerary '];

export const GROUPS_EMAIL_SETTINGS = [
  'quarterlyBusinessMileageComplianceEmailToUsers',
  'quarterlyBusinessMileageComplianceEmailToManagers',
];
